import type { GalleryData_Item } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { AnchorTarget, RelValue } from './../../ricos-types';

import type { GalleryItem } from './convert-to-gallery-item';
import { convertToGalleryItem } from './convert-to-gallery-item';

export const convertToGalleryItemList = (
  items: GalleryData_Item[],
  relValue?: RelValue,
  anchorTarget?: AnchorTarget
): GalleryItem[] => {
  return items.map((item, index) => convertToGalleryItem(item, index, relValue, anchorTarget));
};
